__turbopack_context__.v({
  "name": "trancheField-module-scss-module__cx4hNa__name",
  "nameValueRow": "trancheField-module-scss-module__cx4hNa__nameValueRow",
  "value": "trancheField-module-scss-module__cx4hNa__value",
});
